module.exports = __webpack_public_path__ + "img/icon_logout.d81c804a.svg";